import { BlockLoader, componentLoader } from 'shoutrlabs-block-loader';
// uncomment for blockloader development
// import componentLoader from './componentLoader';
// import BlockLoader from './BlockLoader.vue';
export { BlockLoader, componentLoader };
